import React, { Component } from "react";
import { Row, Col, Card, CardHeader, CardBody, Button } from "reactstrap";
import { Link } from "react-router-dom";
import Grid from "../../../components/Grid/";
import DropDownList from "../../../components/DropDownList";
import { getMySurveys as APIGetMySurveys, getStartSurvey as APIStartSurvey } from "../../../gateways/surveys";
import { getPropertiesByUserId as APIGetProperties } from "../../../gateways/properties";

class List extends Component {
  constructor(props) {
    super(props);

    this.state = {
      surveys: [],
      entries: [],
      properties: []
    };

    this.onSelectedPropertyChanged = this.onSelectedPropertyChanged.bind(this);
  }

  componentWillMount() {
    // this.loadData();
    this.getPropertiesByUser();
  }

  // loadData() {
  //   return APIGetMySurveys().then(result => {
  //     this.setState({
  //       surveys: result.data.surveys,
  //       entries: result.data.entries.map(entry => {
  //         return {
  //           ...entry.survey,
  //           entry_status: entry.status
  //         };
  //       })
  //     });
  //   });
  // }

  getMySurveysByHotel(property) {
    return APIGetMySurveys(property.id).then(result => {
      this.setState({
        surveys: result.data.surveys,
        entries: result.data.entries.map(entry => {
          return {
            ...entry.survey,
            entry_status: entry.status,
            entryId: entry.id,
            hotelId: property.id
          };
        })
      });
    });
  }

  getPropertiesByUser() {
    APIGetProperties().then(result => {
      if (!result.error) {
        const properties = result.data;
        const property = this.props.location.state ? this.props.location.state.property : properties[0];
        this.setState({ properties: properties, property: property });
        this.onSelectedPropertyChanged(property);
      }
    });
  }

  onSelectedPropertyChanged(property) {
    if (property != null) {
      this.getMySurveysByHotel(property);
    }
    this.setState({ property: property });
  }

  getSurveyGridButtons(row) {
    return (
      <div>
        <Button
          className="btn btn-sm"
          onClick={() => {
            this.startSurvey(row.id);
          }}
        >
          <i className="fa fa-play"></i>&nbsp;Start
        </Button>
      </div>
    );
  }

  renderSurveysList() {
    let columns = [
      {
        key: "tools",
        type: "custom",
        render: row => this.getSurveyGridButtons(row)
      },
      {
        key: "name",
        type: "string",
        name: "Name",
        minWidth: "150px"
      },
      {
        key: "start_date",
        type: "datetime",
        name: "Start Date",
        minWidth: "150px"
      },
      {
        key: "end_date",
        type: "datetime",
        name: "Date Due",
        minWidth: "150px"
      },
      {
        key: "status",
        type: "string",
        query: {
          on_going: "On Going",
          // finished: "Finished"
        },
        name: "Status"
      }
    ];
    return (
      <div>
        {this.renderPropertyDdl()}
        <div className="clearfix"></div>
        <Card>
          <CardHeader>
            <strong>New Surveys</strong>
          </CardHeader>
          <CardBody>
            <Grid
              columns={columns}
              data={this.state.surveys}
              pagination={false}
              showTotal={false}
            />
          </CardBody>
        </Card>
      </div>
    );
  }

  startSurvey(id) {
    const data = {
      hotelId: this.state.property.id
    };

    APIStartSurvey(id, data).then(() => {
      // this.props.history.push({pathname: `/my-surveys/view/${id}`, state: { property: this.state.property }});
      this.props.history.push(`/my-surveys/view/${id}/${data.hotelId}`);
    });
  }

  getStartedSurveyGridButtons(row) {
    return (
      <div>
        <Link to={"/my-surveys/view/" + row.id + "/" + row.hotelId}>
          <Button className="btn btn-sm">
            <i className="fa fa-eye"></i>&nbsp;View
          </Button>
        </Link>
      </div>
    );
  }

  renderPropertyDdl() {
    return (
      <div className="pull-right" style={{ paddingBottom: 5 }}>
        <DropDownList 
          items={this.state.properties}
          selected={this.state.property}
          title={'Select property'}
          onSelectedChanged={this.onSelectedPropertyChanged} />
      </div>
    );
  }

  renderStartedSurveysList() {
    let columns = [
      {
        key: "tools",
        type: "custom",
        render: row => this.getStartedSurveyGridButtons(row)
      },
      {
        key: "name",
        type: "string",
        name: "Name",
        minWidth: "150px"
      },
      {
        key: "start_date",
        type: "datetime",
        name: "Start Date",
        minWidth: "150px"
      },
      {
        key: "end_date",
        type: "datetime",
        name: "Date Due",
        minWidth: "150px"
      },
      {
        key: "status",
        type: "string",
        query: {
          // finished: "Finished",
          on_going: "On Going"
        },
        name: "Status"
      },
      {
        key: "entry_status",
        type: "string",
        query: {
          submitted: "Yes",
          unsubmitted: "No"
        },
        name: "Submitted"
      }
    ];
    return (
      <Card>
        <CardHeader>
          <strong>Started Surveys</strong>
        </CardHeader>
        <CardBody>
          <Grid
            columns={columns}
            data={this.state.entries}
            pagination={false}
            showTotal={false}
          />
        </CardBody>
      </Card>
    );
  }

  render() {
    return (
      <div className="animated fadeIn">
        <Row>
          <Col xs="12">
            {this.renderSurveysList()}
            {this.renderStartedSurveysList()}
          </Col>
        </Row>
      </div>
    );
  }
}

export default List;



// WEBPACK FOOTER //
// ./src/views/MySurveys/List/List.js